import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Checkbox,
  IconButton,
  Link,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Tooltip,
} from "@mui/material";
import EditIcon from "../../../src/assests/images/edit-2.svg";
import DeleteIcon from "../../../src/assests/images/trash.svg";
import DeleteTopIcon from "../../../src/assests/images/deleteIcon.svg";
import ViewToggle from "./ViewToggle";
import FilterTags from "./FilterTags";
import RenderSelectedFilters from "./RenderSelectedFiltersProps";
import closeIcon from "../../../src/assests/images/close-circle.svg";
import { viewcohorts, deletecohort } from "../../pages/assign-task/api";
import { useLocation } from "react-router-dom";
import EditCohort from "./EditCohort";
import { Height } from "@mui/icons-material";
import { getToken } from "../../utils/utils";
import { CircularProgress } from "@mui/material";
import { useAlert } from "../../pages/AlertContext/AlertContext";
import PaginationComponent from "../../pages/brands/Pagination";
import { createJSDocAuthorTag } from "typescript";

const initialCohorts = [
  {
    name: "Cohort 1",
    users: 3000,
    checked: false,
  },
  {
    name: "Cohort 2",
    users: 3000,
    checked: false,
  },
  {
    name: "Cohort 3",
    users: 3000,
    checked: false,
  },
];

const CohortCard = ({ cohorts, cohort, onToggle, onDelete, chortids ,setSelectedCohortname}: any) => {
  const outletType = Array.isArray(cohort.outlet_type)
    ? cohort.outlet_type
    : [cohort.outlet_type];

  const locationType = Array.isArray(cohort.location_type)
    ? cohort.location_type
    : [cohort.location_type];

  const combainesalldata = [...outletType, ...locationType];

  console.log(combainesalldata, "cohortcohortcohortcohortcohort111");

  const handleEditCohort = (id: string) => {
    // Perform any action with the cohort_id
    // For example, open a dialog or update state
    console.log(`Editing cohort with ID: ${id}`); // Optional: Remove or replace this
  };

  // const [selectedCohorts, setSelectedCohorts] = useState(cohorts);
  const [selectedCohorts, setSelectedCohorts] = useState<number[]>([]);
 


  console.log(cohorts, "cohortvvvvvvvvvvvvvvvvvvvvv")
  const isSelected = chortids.includes(cohort.cohort_id);
  console.log(isSelected, "selectedCohortsssssssss")
  console.log(cohort.outlet_type, "outlet_typeoutlet_type")
  console.log(cohort.is_assigned,"isassigned")

  const outletTypeLabelMap = (cohort.cort_type || []).reduce((acc: Record<string, string>, item: any) => {
    acc[item.value] = item.label;
    return acc;
  }, {});


  const rentalPattern = /^\d+-\d+$/;        // e.g. "2000-4000"
  const contractPattern = /^Last\d+Year$/i; // e.g. "Last3Year"

  const outletTypeFilters = (cohort.outlet_type || []).filter(
    (val: string) => !rentalPattern.test(val) && !contractPattern.test(val)
  );
  const rentalValueFilters = (cohort.outlet_type || []).filter((val: string) =>
    rentalPattern.test(val)
  );
  const contractSinceFilters = (cohort.outlet_type || []).filter((val: string) =>
    contractPattern.test(val)
  );

   const date = new Date(cohort.created_at);

          const day = date.getDate();
          const suffix =
            day % 10 === 1 && day !== 11
              ? "st"
              : day % 10 === 2 && day !== 12
                ? "nd"
                : day % 10 === 3 && day !== 13
                  ? "rd"
                  : "th";

          const month = date.toLocaleString("en-US", { month: "short" }); // "Jan", "Feb", "Sep"
          const year = date.getFullYear();

         
          const hours = date.getHours(); // 0-23
          const minutes = date.getMinutes().toString().padStart(2, "0");

          const formattedDate = `${day}${suffix} ${month} ${year}, ${hours}:${minutes}`;
          console.log(cohort, "cohortcohortwww33333")

          
  return (
    <Card
      sx={{
        // maxWidth: "50%",
        margin: 2,
     
        //border: "1px solid rgba(0, 0, 0, 0.12)",
        borderRadius: "10px",
        // boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
        boxShadow: "none",
        transition: "box-shadow 0.3s ease-in-out",
        position: "relative",
        minWidth: "30%",
        maxWidth: "30%",

        "&:hover": {
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
        },
        "@media (max-width: 1280px)": {
          minWidth: "29%",
          maxWidth: "29%",
        },
      }}
    >
      <CardContent sx={{ padding: "10px 16px 13px !important" }}>
        <Box display="flex" justifyContent="space-between" alignItems="top" sx={{ borderBottom: "1px dashed #E7E8E9" }}>
          <Typography variant="h6" fontWeight="bold">
            <Tooltip title={cohort.cohort_name} arrow>
              <Link
                href={`/cohort-user/${cohort.cohort_id}`}
                underline="none"
                color="inherit"
                sx={{
                  display: "inline-block", marginRight: "8px", fontSize: "18px", paddingTop: "5px",
                  width: {
                    // optional intermediate step
                    lg: "150px",
                    xl: "200px",
                  },
                  wordBreak: "break-word",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",

                  "@media (max-width: 1280px)": {
                    xl: "165px",
                  }
                }}
              >
                {cohort.cohort_name}
              </Link>
            </Tooltip>
          </Typography>
          {/* {!cohort.is_assigned && ( */}
          {/* {!cohort.is_assigned && cohort.taskCount==='not reqired' || cohort.taskCount>0 &&( */}
{/* {(
  !cohort.is_assigned
    ? cohort.taskCount === 'not required' || cohort.taskCount > 0
    : cohort.is_assigned
) && ( */}
          <Checkbox
            checked={isSelected}
             onChange={() => onToggle(cohort)} sx={{
              padding: "4px 6px 10px",
              color: "#d8d8d8", // unselected color
              '&.Mui-checked': {
                // color: "#d8d8d8", // checked color
              },
              '&.MuiCheckbox-root': {
                verticalAlign: "top",
                height: "38px"
              },
              '&:hover': {
                backgroundColor: "transparent", // remove hover background
              },
            }}
          />
    
        </Box>

        <Typography variant="body1" sx={{ marginY: 1,  }}>
          Total Users: <b>{cohort.distinctRetailersCount}</b>

        </Typography>
      {(cohort.is_assigned || cohort.is_scheduled === "1") && (
  <Typography
    variant="body1"
    sx={{
      display: "inline-block",
      padding: "7px 10px",
      borderRadius: "10px",
      fontWeight: 600,
      fontSize: "12px",
      backgroundColor: cohort.is_assigned
        ? "#E3E3E3"
        : cohort.is_scheduled === "1"
        ? "#F0F0F0"
        : "transparent",
      color: cohort.is_assigned
        ? "#2E844A"
        : cohort.is_scheduled === "1"
        ? "#696A6B"
        : "#000",
    }}
  >
    {cohort.is_assigned
      ? "Published"
      : cohort.is_scheduled === "1"
      ? "Not Published"
      : ""}
  </Typography>
)}


        <Typography variant="body1" sx={{ marginY: 1, fontSize:"14px", fontWeight:"400" }}>
          
          created_at: <b>{formattedDate}</b>
        </Typography>
        {/* {cohort.outlet_type?.length > 0 && (
        <FilterTags
          title="Applied Filters :"
          combainesalldata={cohort.outlet_type}
          showAllInitially={false}
          showCloseBtn={false}
          appliedFilters={cohort.outlet_type}
        />
)} */}
        {/* <RenderSelectedFilters
          maxVisible={3}
          showAllInitially={false}
          showTitle={true}
          title=""
          showCloseBtn={false}
          filters={{}} tasks={[]}        /> */}
   {((cohort.outlet_type?.length ?? 0) > 0 ||
  (cohort.location_type?.length ?? 0) > 0 ||
  (cohort.tasks?.length ?? 0) > 0) ? (

            <RenderSelectedFilters
              maxVisible={3}
              showAllInitially={false}
              showTitle={true}
              title="Applied Filters"
              showCloseBtn={false}
              filters={{
                outlet_type: outletTypeFilters.reduce((acc: any, filter: string) => {
                  acc[filter] = true;
                  return acc;
                }, {}),
                Current_rental_value: rentalValueFilters.reduce((acc: any, filter: string) => {
                  acc[filter] = true;
                  return acc;
                }, {}),
                Contract_since: contractSinceFilters.reduce((acc: any, filter: string) => {
                  acc[filter] = true;
                  return acc;
                }, {}),
                 locations: (cohort.location_type || []).reduce((acc: any, filter: string) => {
      acc[filter.toUpperCase()] = true;   // ✅ uppercase for locations
      return acc;
    }, {}),
                taskNames: (cohort.tasks || []).reduce((acc: any, task: any) => {
                  acc[task.id] = true;
                  return acc;
                }, {}),
              }}
              tasks={cohort.tasks || []}
              formatRentalValueLabel={(range) => {
                const [min, max] = range.split("-");
                return `₹${min}-₹${max}`;
              }}
              formatContractSinceLabel={(value) =>
                value
                  .replace(/([A-Za-z]+)(\d+)/, "$1 $2")
                  .replace(/(\d+)([A-Za-z]+)/, "$1 $2")
              }
            />


) : (
<div style={{ textAlign: "center", color: "#c8172f" ,marginTop: "49px"}}>
  No filters applied
</div>)}

          {!cohort.is_assigned  && (
          <Box
            sx={{
              display: "none",
              position: "absolute",
              top: "10px",
              right: "60px",
              zIndex: "1",
              height: "30px",
              "&:hover, .MuiCard-root:hover &": {
                display: "flex",
                width: "60px",
                overflow: "hidden",
              },
            }}
          >
            {/* <Tooltip title="Delete" arrow> */}
            <IconButton
              size="small"
              color="error"
        // onClick={() => onDelete(cohort.cohort_id)

        // }
        onClick={() => {
    onDelete(cohort.cohort_id);
    setSelectedCohortname(cohort.cohort_name);
  }}
            >
              <img src={DeleteIcon} alt="delete" width={16} />
            </IconButton>
            {/* </Tooltip> */}

            {/* <Tooltip title="Edit" arrow> */}
            <IconButton size="small" color="primary">
              <EditCohort
                buttonText="Edit"
                buttonVariant="outlined"
                buttonIcon={EditIcon}
                type="edit"
                cohortId={cohort.cohort_id}
                cohortname={cohort.cohort_name}
                outletType={cohort.outlet_type}
                cohort_type={cohort.cohort_type}
                outletnames={cohort.formattedRetailers}
                onClick={(id: any) => console.log("Edit cohort:", id)}
              />
            </IconButton>
            {/* </Tooltip> */}
          </Box>
        )}
      </CardContent>

    </Card>
  );
};

// CohortView component
interface Cohort {
  cohort_id: any;
  name: string;
  users: number;
  checked: boolean;
  tasks?: { id: string; credit_points?: string }[];
  distinctRetailersCount?: number;
  is_assigned?: boolean;
}

interface CohortViewProps {
  title: string;
  cohortIds: string[]; // Renamed from chortids to cohortIds
  setCohortIds: React.Dispatch<React.SetStateAction<string[]>>; // Renamed to match

  cohortIds2: string[]; // Renamed from chortids to cohortIds
  setCohortIds2: React.Dispatch<React.SetStateAction<string[]>>;
  debouncedSearchTerm: string;
  searchTerm: string
  value: string
    selectedCohortStatuses: Record<string, string>;
  setSelectedCohortStatuses: React.Dispatch<React.SetStateAction<Record<string, string>>>;
    selectedTaskIds: string[];
  setSelectedTaskIds: React.Dispatch<React.SetStateAction<string[]>>;

 cohortSchedules: { [key: string]: string };
  setCohortSchedules: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
    totalCreditPoints: number;
  setTotalCreditPoints: React.Dispatch<React.SetStateAction<number>>;
  totalRetailers: number;
  setTotalRetailers: React.Dispatch<React.SetStateAction<number>>;
}
const CohortView: React.FC<CohortViewProps> = ({ selectedTaskIds,        // ✅ new prop
  setSelectedTaskIds, selectedCohortStatuses,
  setSelectedCohortStatuses,title, cohortIds, setCohortIds, cohortIds2, setCohortIds2, debouncedSearchTerm, searchTerm, value,cohortSchedules, setCohortSchedules , totalCreditPoints,
  setTotalCreditPoints,
  totalRetailers,
  setTotalRetailers}) => {
  const [cohorts, setCohorts] = useState<Cohort[]>([]);
console.log(cohortIds, "cohortIds88888888888888")
  // const [selectedCohorts, setSelectedCohorts] = useState<Cohort[]>([]);
  // const [totalCreditPoints, setTotalCreditPoints] = useState(0);
  // const [totalRetailers, setTotalRetailers] = useState(0);
  // const [chortids, setchortids] = useState<string[]>([]); // Ensure it's an array
  console.log(searchTerm, "searcoooooooohTerm")

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [Totalcount, setTotalcount] = useState(0);



  const token = getToken();
  const [cohortslength, setcohortslength] = useState(0);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [cohortToDelete, setCohortToDelete] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();
  // const [cohortSchedules, setCohortSchedules] = useState<{ [key: string]: string a

  // const [selectedTaskIds, setSelectedTaskIds] = useState<string[]>([]); // ✅ New state for selected task IDs

   const [selectedCohortsname, setSelectedCohortname] = useState('');
  //  const [selectedCohortStatuses, setSelectedCohortStatuses] = useState<Record<string, string>>({});
console.log(cohortSchedules, "cohortSchedules7889999")
  const perpagedata = 10;
  const limit = 12;
  const { showAlert } = useAlert();
  console.log(cohortIds, "cohortIdsccco44hortIds")
  const fetchCohorts = async () => {
    try {
      setLoading(true);
      const response = await viewcohorts(
        {
          search: Number(value) === 1 ? debouncedSearchTerm : "",
          page: String(page),
          limit: String(limit),
        },
        token
      );
      console.log("Fetched Cohorts:", response);
      if (response?.data?.data) {
        setCohorts(response.data.data.final);
        console.log(response.data.data.final, "response.data.data.final4444")
        setcohortslength(response.data.data.total_cohorts ?? 0);
      } else {
        console.error("Unexpected API response:", response);
      }
    } catch (error) {
      console.error("Error fetching cohorts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token && Number(value) === 1) {
      fetchCohorts();
    }
  }, [page, limit, value, debouncedSearchTerm, token]);
  console.log(value, "value5555555555")

  const totalPages1 = Math.ceil(cohortslength / limit);
  // console.log(title, "titletitletitletitle")
  console.log(cohorts, "cohortscohortscohortscohorts");
  console.log(cohortslength, "cohortslengthssssssssssss",totalPages1)
  if (loading) {
    return (
      <Box sx={{ margin: "auto", textAlign: "center" }}>
        <CircularProgress />;
      </Box>
    );
  }

  if (cohorts.length === 0) {
    return <Typography sx={{ textAlign: "center" }}>No cohorts available.</Typography>;
  }
console.log(selectedTaskIds, "selectedTaskIds99666666666")
const handleToggleCheckbox = (cohort: any) => {
  const cohortId = cohort.cohort_id;
  const cohortSchedule = cohort.is_scheduled; // should be string like "0" or "1"
  console.log(cohort.distinctRetailersCount, "cohort.distinctRetailersCount77888")
const taskIds: string[] = Array.isArray(cohort.task_id)
    ? cohort.task_id.map((id: number | string) => String(id))
    : cohort.task_id
    ? String(cohort.task_id)
        .split(",")
        .map((id) => id.trim())
    : [];

  // Toggle selected IDs
  setCohortIds((prev) =>
    prev.includes(cohortId)
      ? prev.filter((id) => id !== cohortId)
      : [...prev, cohortId]
  );


 setSelectedTaskIds((prev) => {
    if (cohortIds.includes(cohortId)) {
      // If unchecking — remove all related task IDs
      return prev.filter((id) => !taskIds.includes(id));
    } else {
      // If checking — add all related task IDs (unique)
      const uniqueTasks = Array.from(new Set([...prev, ...taskIds]));
      return uniqueTasks;
    }
  });
  // Toggle cohort statuses
  setSelectedCohortStatuses((prev) => {
    if (prev[cohortId]) {
      // If already selected, remove it
      const newStatuses = { ...prev };
      delete newStatuses[cohortId];
      return newStatuses;
    } else {
      // Add selected cohort with its status
      return { ...prev, [cohortId]: cohort.is_assigned || "unknown" };
    }
  });

  // Toggle cohort checked state
  setCohorts((prev) =>
    prev.map((c) =>
      c.cohort_id === cohortId ? { ...c, checked: !c.checked } : c
    )
  );

  const isCurrentlyChecked = cohort.checked; // true if it was checked before toggle

  // Update cohortSchedules
  setCohortSchedules((prev) => {
    const newSchedules = { ...prev };

    if (isCurrentlyChecked) {
      // If it was checked and now is unchecked, remove it
      delete newSchedules[cohortId];
    } else {
      // If checking, only add real schedule value
      if (cohortSchedule !== undefined && cohortSchedule !== null) {
        newSchedules[cohortId] = String(cohortSchedule);
      }
    }

    return newSchedules;
  });

  // Calculate and set credit points only if cohort.is_assigned is true
  if (cohort.is_assigned) {
    let points = 0;
    points = Number(cohort.totalCredits || 0) * (cohort.distinctRetailersCount || 0);

    if (!isCurrentlyChecked) { // checking
      setTotalCreditPoints((prev) => prev + points);
    } else { // unchecking
      setTotalCreditPoints((prev) => prev - points);
    } 
  }
  let retailers = cohort.distinctRetailersCount || 0;
    if (!isCurrentlyChecked) { // checking
      setTotalRetailers((prev) => prev + retailers);
    } else { // unchecking
      setTotalRetailers((prev) => prev - retailers);
    }
};


console.log(totalRetailers, "totalRetailers7888888")
  console.log(cohorts, "cohortscohortscohorts");
  console.log(cohortIds, "chortidsddddddddswwwwwwww")

  const handleDeleteCohort = (name: string) => {
    console.log(name, "jjjjjjjjjjjjjjjjjjjjj");
    setCohortToDelete(name);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = async () => {
    console.log(cohortToDelete, "cohortToDeletecohortToDeletecohortToDelete");
    showAlert("Delete cohort...", "info");
    try {
      const response = await deletecohort({ cohort_id: cohortToDelete }, token);

      if (response && response.status === 200) {
        setCohorts(cohorts.filter((cohort) => cohort.name !== cohortToDelete));
        showAlert("Cohort deleted successfully!", "success");
         await fetchCohorts();
        setOpenDeleteDialog(false);
      } else {
        console.error("Failed to delete cohort", response);
        showAlert("Failed to delete cohort. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error while deleting cohort:", error);
      showAlert("An error occurred while delete the cohort.", "error");
    }
  };

  const cancelDelete = () => {
    setOpenDeleteDialog(false);
  };

  const handleClose = () => {
    setOpenDeleteDialog(false);
  };
  
  console.log(cohorts, "viewcohortsviewcohortsviewcohortsviewcohorts");
  console.log(debouncedSearchTerm, "sssssssssssssss")
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >

        {/* <Box>
          <ViewToggle />
        </Box> */}

      </Box >

      {
        loading ? (
          <CircularProgress />
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : (
          <Grid
            container
            spacing={2}
            justifyContent="left"
            sx={{ marginBottom: 5 }}
          >
            {cohorts.length > 0 ? (
              cohorts.map((cohort, index) => (
                <CohortCard
                  key={cohort.name}
                  cohort={cohort}
               onToggle={handleToggleCheckbox} 
                  onDelete={handleDeleteCohort}
                  chortids={cohortIds}
                  cohorts={cohorts}
                  setSelectedCohortname={setSelectedCohortname}
                />
              ))
            ) : (
              <div>No data found</div>
            )}
          </Grid>
        )}

      <Dialog open={openDeleteDialog} onClose={cancelDelete} sx={{
        width: "510px", margin: "auto",
        "& .MuiDialog-paper": { borderRadius: "10px" }
      }}>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #E9E9E9", padding: "10px 0px", margin: "0 24px 10px" }}>
          <Typography sx={{ display: "flex" }}>
            <img src={DeleteTopIcon} alt="Delete" />
            <Typography
              sx={{ fontSize: "24px", fontWeight: "600", marginLeft: "15px" }}
            >
              Delete Cohort
            </Typography>
          </Typography>
          <Box>
            <Tooltip title="Close the Delete" arrow>
              <Button
                onClick={handleClose}
                color="primary"
                sx={{
                  borderRadius: "50%",
                  color: "#000",
                  fontSize: "10px",
                  position: "relative",
                  right: "-20px",
                  width: "15px",
                  background: "#fff",
                  "& :hover": {
                    background: "#fff"
                  }
                }}
              >
                <img src={closeIcon} alt="close" width="15px" />
              </Button>
            </Tooltip>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: "16px" }}>
  Are you sure you want to delete the{" "}
  <Box component="span" sx={{ fontWeight: "bold" }}>
    "{selectedCohortsname}"
  </Box>{" "}
  cohort? This will remove all grouped users.
</Typography>
        </DialogContent>
        <DialogActions sx={{ marginBottom: "20px" }}>
          <Button
            onClick={confirmDelete}
            color="error"
            sx={{
              border: "1px solid #C8172F",
              color: "#C8172F",
              width: "112px",
              padding: "10px 0",
              borderRadius: "10px",
              marginRight: "20px",
            }}
          >
            Yes
          </Button>
          <Button
            onClick={cancelDelete}
            color="primary"
            sx={{
              border: "1px solid #E7E8E9",
              color: "#000",
              width: "112px",
              padding: "10px 0",
              borderRadius: "10px",
              marginRight: "20px",
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ marginBottom: "20px", paddingBottom: "30px" }}>
        <PaginationComponent page={page} limit={limit} totalPages={totalPages1} setPage={setPage} />
      </Box>
    </>
  );
};

export default CohortView;